import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BuscaService } from 'src/app/services/busca.service';
import { HistoricoEscolar } from 'src/app/models/historicoEscolar';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-diploma',
    templateUrl: './diploma.component.html',
    styleUrls: ['./diploma.component.scss'],
    standalone: false
})
export class DiplomaComponent implements OnInit {

  pdf: any;
  downloadLinkXML: SafeResourceUrl;
  downloadLinkRVHE: SafeResourceUrl;

  xmlFile: string;
  codigo: string = '';

  nomeArquivoXML: string = `historico_escolar_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.xml`;
  nomeArquivoRVHE: string = `historico_escolar_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.pdf`;

  resultadoBusca: HistoricoEscolar = null;
  semXML = false;

  erro: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _busca: BuscaService,
    private domSanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.route.paramMap.subscribe(paramMap => {
      this.codigo = paramMap.get('id');
    });

    this.buscar();
  }

  buscar() {
    this._busca.getHistorico(this.codigo, '').subscribe(response => {
      if (response.length > 0) {
        this.resultadoBusca = response[0];

        // Se for Pós, Mestrado e Doutorado, não exibir botões do XML
        // 1 - Especialização(Pós) | 3 - Mestrado(Doutorado) | 4 - Graduação Tecnológica | 11 - Graduação | 45 - Mestrado
        if (this.resultadoBusca.codTipoCurso === 1 || this.resultadoBusca.codTipoCurso === 3 || this.resultadoBusca.codTipoCurso === 45) {
          this.semXML = true;
        }

        // Printa o XML na tela
        this.pdf = this.getPDF(this.resultadoBusca.imgRVHE);

        // Link para download do arquivo XML
        this.downloadLinkXML = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/octet-stream;base64,' + this.resultadoBusca.codXMLPublico);

        // Link para download do arquivo PDF
        this.downloadLinkRVHE = this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf);
      } else {
        this.erro = true;
        this.router.navigate(['/hed']);
      }

      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      this.erro = true;
      this.router.navigate(['/hed']);

      if (error.status === 404) {
        this.resultadoBusca = null;
      } else {
        console.log(error);
      }
    });
  }

  getPDF(pdf: string) {
    const byteArray = new Uint8Array(atob(pdf).split('').map(char => char.charCodeAt(0)));
    let blob = new Blob([byteArray], {
      type: 'data:application/pdf'
    });

    return URL.createObjectURL(blob);
  }

  formataCPF(cpf: string | number) {
    return String(cpf).padStart(11, '0');
  }
}
